import { FC } from "react";
import ClearButton from "shared/components/ClearButton";
import Filter from "shared/components/Filter";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import SearchField from "shared/components/SearchField";
import { useStaticTranslationPage } from "../../context";

const PageFilterBar: FC = () => {
  const {
    searchValue,
    onSearchTranslation,
    onClearFilterValues,
    areaFilterData,
    contentItemFilterData,
    isLoadingTable,
  } = useStaticTranslationPage();

  return (
    <FlexCenter columnGap={"1rem"} marginBottom={"1rem"}>
      <SearchField
        placeholder="Search"
        value={searchValue}
        onChange={onSearchTranslation}
      />
      <Filter
        title="Area"
        {...areaFilterData}
        disabled={isLoadingTable}
        sortAlphabetically
      />
      <Filter
        title="Content item"
        {...contentItemFilterData}
        disabled={isLoadingTable}
        sortAlphabetically
      />
      {(areaFilterData.selectedValue.length > 0 ||
        contentItemFilterData.selectedValue.length > 0) && (
        <ClearButton onClearFilters={onClearFilterValues} />
      )}
    </FlexCenter>
  );
};

export default PageFilterBar;
